import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/data-quality`;

export const dataQualityService = {
  // Dashboard endpoints
  getDashboardMetrics: async () => {
    const response = await axios.get(`${API_BASE}/dashboard/metrics`);
    return response.data;
  },

  getDashboardTrends: async (timeRange = '30d') => {
    const response = await axios.get(`${API_BASE}/dashboard/trends?timeRange=${timeRange}`);
    return response.data;
  },

  getDashboardDimensions: async () => {
    const response = await axios.get(`${API_BASE}/dashboard/dimensions`);
    return response.data;
  },

  getTopFailingRules: async (limit = 10) => {
    const response = await axios.get(`${API_BASE}/dashboard/top-rules?limit=${limit}`);
    return response.data;
  },

  // Rules endpoints
  getRules: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.dimension_type) params.append('dimension_type', filters.dimension_type);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);
    const response = await axios.get(`${API_BASE}/rules?${params}`);
    return response.data;
  },

  getRuleById: async (ruleId) => {
    const response = await axios.get(`${API_BASE}/rules/${ruleId}`);
    return response.data;
  },

  createRule: async (ruleData) => {
    const response = await axios.post(`${API_BASE}/rules`, ruleData);
    return response.data;
  },

  updateRule: async (ruleId, ruleData) => {
    const response = await axios.put(`${API_BASE}/rules/${ruleId}`, ruleData);
    return response.data;
  },

  deleteRule: async (ruleId) => {
    const response = await axios.delete(`${API_BASE}/rules/${ruleId}`);
    return response.data;
  },

  // Entity endpoints
  getEntities: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.type) params.append('type', filters.type);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);
    const response = await axios.get(`${API_BASE}/entities?${params}`);
    return response.data;
  },

  getEntityQuality: async (entityType, entityId) => {
    const response = await axios.get(`${API_BASE}/entities/${entityType}/${entityId}/quality`);
    return response.data;
  },

  getEntityIssues: async (entityType, entityId) => {
    const response = await axios.get(`${API_BASE}/entities/${entityType}/${entityId}/issues`);
    return response.data;
  },

  // Impact endpoints
  getImpactAnalysis: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.category) params.append('category', filters.category);
    if (filters.severity) params.append('severity', filters.severity);
    const response = await axios.get(`${API_BASE}/impact?${params}`);
    return response.data;
  },

  getErrorDistribution: async () => {
    const response = await axios.get(`${API_BASE}/impact/distribution`);
    return response.data;
  },

  // Details endpoints
  getQualityDimensions: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.entityType) params.append('entityType', filters.entityType);
    const response = await axios.get(`${API_BASE}/details/dimensions?${params}`);
    return response.data;
  },

  getQualityTrends: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.timeRange) params.append('timeRange', filters.timeRange);
    if (filters.entityType) params.append('entityType', filters.entityType);
    const response = await axios.get(`${API_BASE}/details/trends?${params}`);
    return response.data;
  }
};

export default dataQualityService;
